import { render, staticRenderFns } from "./awards.vue?vue&type=template&id=819d35b6&scoped=true&"
import script from "./awards.vue?vue&type=script&lang=js&"
export * from "./awards.vue?vue&type=script&lang=js&"
import style0 from "./awards.vue?vue&type=style&index=0&id=819d35b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "819d35b6",
  null
  
)

export default component.exports